import { _ as r } from "./index.es384.js";
var a = r, o = a["__core-js_shared__"], s = o;
export {
  s as _
};
//# sourceMappingURL=index.es505.js.map
